export default [
  {
    path: '/modules/financial/ajuste-conta',
    name: 'ajuste-conta-list',
    component: () => import('@/views/modules/financial/ajustes-conta/AjusteContaList.vue'),
    meta: {
      action: ['ROLE_AJUSTE_DE_CONTA_CONSULTAR'],
      resource: 'ACL',
      pageTitle: 'Histórico de Ajustes de Conta',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Movimentações' },
        { text: 'Ajustes', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/ajuste-conta/add',
    name: 'ajuste-conta-form',
    component: () => import('@/views/modules/financial/ajustes-conta/AjusteContaForm.vue'),
    meta: {
      action: ['ROLE_AJUSTE_DE_CONTA_INSERIR'],
      resource: 'ACL',
      pageTitle: 'Novo Ajuste',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Ajustes', to: { name: 'ajuste-conta-list' } },
        { text: 'Novo', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/ajuste-conta/detail/:id',
    name: 'ajuste-conta-detail',
    component: () => import('@/views/modules/financial/ajustes-conta/AjusteContaDetail.vue'),
    meta: {
      action: ['ROLE_AJUSTE_DE_CONTA_CONSULTAR'],
      resource: 'ACL',
      pageTitle: 'Detalhes do Ajuste',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Ajustes', to: { name: 'ajuste-conta-list' } },
        { text: 'Detalhes', active: true },
      ],
    },
  },
]
